module.exports = __webpack_public_path__ + "static/media/ic_avtar.f07d66e0.png";